import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';

const MDSelectGroup = forwardRef(({ label, variant, data, readOnly, ...rest }, ref) => {
  if (readOnly) return <MDInput {...rest} value={rest.value} InputProps={{ readOnly: true }} />;

  return (
    <MDBox>
      <InputLabel sx={{ lineHeight: 1.2 }}>{label}</InputLabel>
      <Autocomplete
        {...rest}
        options={data}
        isOptionEqualToValue={(option, v) => option.id === v.id}
        getOptionLabel={(option) => option.name}
        noOptionsText='-'
        renderOption={(props, option) => {
          if (option.parent === 'Y')
            return (
              <MDBox component='li' key={option.key}>
                - {option.parent_name}
              </MDBox>
            );

          return (
            <MDBox component='li' {...props} key={option.key}>
              {option.name}
            </MDBox>
          );
        }}
        renderInput={(params) => (
          <MDInput variant={variant} {...params} InputLabelProps={{ shrink: true }} fullWidth />
        )}
      />
    </MDBox>
  );
});

export default MDSelectGroup;

MDSelectGroup.defaultProps = {
  variant: 'standard',
  readOnly: false,
};

MDSelectGroup.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.string,
  readOnly: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};
